import * as React from "react";

type Tab = "eligible" | "requests" | "listed";

interface TabCounts {
  eligible: number;
  requests: number;
  listed: number;
}

const TabSwitcher = ({
  active,
  onChange,
  counts,
}: {
  active: Tab;
  onChange: (tab: Tab) => void;
  counts?: TabCounts;
}) => {
  const tabs: Tab[] = ["eligible", "requests", "listed"];
  return (
    <div className="flex justify-between mb-2">
      {tabs.map(tab => (
        <div key={tab} className="flex flex-col items-center w-full ">
          <button
            onClick={() => onChange(tab)}
            className={`w-full flex-1 py-[10px] text-[22px] leading-none uppercase flex flex-col items-center gap-1  ${tab === "eligible" ? "bg-primary-blue" : tab === "listed" ? "bg-green-500" : "bg-primary-gray"}
            `}
          >
            <span>{tab.toUpperCase()}</span>
            {counts && <span className="text-[22px]">{counts[tab]}</span>}
          </button>
          <div
            className={`w-full h-[7px]  ${tab == active && "bg-light-gray"}`}
          ></div>
        </div>
      ))}
    </div>
  );
};

export default TabSwitcher;
